import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';
import { Link } from 'react-router-dom';
import SearchBar from '../../../../components/table/SearchBar';
import { debounce } from '../../../../shared/helpers';
import { users_actions } from '../redux/actions/users.actions';

class UsersFilters extends Component {
    local_path = 'User_list_table.filters';

    handleChangeFilter = (key, value) => {
        this.props.dispatch(users_actions.setFilter(`${this.local_path}.${key}`, value));
        this.updateData();
    }

    requestData = init => this.props.dispatch(users_actions.getUsersRequest(this.props.filters, init));

    updateData = debounce(this.requestData, 500);

    render() {
        return (
            <Fragment>
                <FormGroup row>
                    <SearchBar
                        onClickRefresh={this.updateData}
                        onSearch={value => this.handleChangeFilter('searchText', value)}
                        searchPlaceholder="Search by first name, last name or department"
                        searchStyle={{ minWidth: 350 }}
                        searchValue={this.props.filters.searchText}
                        menu={{
                            items: [
                                {
                                    content: <Link style={{ color: 'inherit' }} to="/UserManagement/User_create">Add User</Link>,
                                    icon: 'add',
                                },
                            ],
                        }}
                    />
                    <div style={{ marginLeft: '10px' }}>
                        <FormControlLabel
                            control={(
                                <Checkbox
                                    checked={this.props.filters.hideDuplicate}
                                    onChange={event => this.handleChangeFilter('showSuspendent', event.target.checked)}
                                    name="Show suspended users"
                                    color="primary"
                                />
                            )}
                            label="Show suspended users"
                        />
                    </div>
                </FormGroup>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    filters: { ...state.UserManagement.User_list.User_list_table.filters },
});

export default connect(mapStateToProps)(UsersFilters);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/components/UsersFilters.js